export enum DatePickerDataHooks {
  DATE_PICKER = 'date-picker',
  DOT_ICON = 'dot-icon',
}
